<div class="scan-info-container">
  <div class="p-3 inner">
    <div class="file-error-icon">
      <!--<img src="/assets/img/file-broken.svg" alt="Error Icon" />-->
      <i
        class="fa fa-2x"
        [class.fa-spinner]="file.malwareScanningStatus == MalwareScanningStatus.Unscanned"
        [class.fa-pulse]="file.malwareScanningStatus == MalwareScanningStatus.Unscanned"
        [class.fa-times-circle]="file.malwareScanningStatus == MalwareScanningStatus.Quarantined"
        [class.text-danger]="file.malwareScanningStatus == MalwareScanningStatus.Quarantined"></i>
    </div>

    <div class="scan-text" *ngIf="file.malwareScanningStatus == MalwareScanningStatus.Unscanned">
      {{ 'fileTransfer_scanningPreviewText' | translate }}
    </div>
    <div class="scan-text" *ngIf="file.malwareScanningStatus == MalwareScanningStatus.Quarantined">
      {{ 'fileTransfer_quarantinedPreviewText' | translate }}
    </div>
  </div>
</div>
